// extracted by mini-css-extract-plugin
export default {"text":"CustomText_text__rv403"};